import {
  IonButton,
  IonContent,
  IonInput,
  IonLabel,
  IonModal,
} from "@ionic/react";
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  IseditingLookupsState,
  loggedInUserState,
  networkConnectionStatus,
  newAllDropDownState,
} from "../../data/atoms";
import { ActionType, Lookups } from "../../models/Enums";
import { PatientFormDropdowns } from "../../models/PatientFormDropdowns";
import { User } from "../../models/User";
import { AddUpdateLookups } from "../../services/AuthServices";
import {
  getHeaderText,
  getParmeters,
  validationNamePattern,
} from "../../utils/sharedFunction";
interface Props {
  LookUpType: Lookups;
  setShowModal2: Function;
  setIsLookupUpdated: Function;
}
const CreateNewLookup: React.FC<Props> = ({
  setIsLookupUpdated,
  setShowModal2,
  LookUpType,
}) => {
  const [iseditingLookup, setIseditingLookup] = useRecoilState(
    IseditingLookupsState
  );
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus
  );
  const [newAllDropDown, setNewAllDropDown] =
    useRecoilState<PatientFormDropdowns>(newAllDropDownState);
  let [userToEdit, setuserToEditt] = useRecoilState(loggedInUserState);
  const [isDisabled, setIsDisabled] = useState(
    !iseditingLookup.IseditingLookups
  );
  const [name, setName] = useState("");
  // console.log("LookUpType ", LookUpType);
  // console.log("iseditingLookup ", iseditingLookup);

  const {
    register,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: iseditingLookup.Label,
    },
  });

  let history = useHistory();
  async function checkDisableTextValidity(typedValue: string) {
    if (typedValue !== "" && typedValue.trim().length !== 0) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }
  function handleChange(event: any) {
    setName(event.target.value);
    checkDisableTextValidity(event.target.value);
  }

  const updateEditedLookup = (labelName: string) => {
    debugger;
    if (LookUpType === Lookups.Physician) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        physician: { ...prevState.physician, name: labelName },
      }));
    } else if (LookUpType === Lookups.Referral) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        referral: { ...prevState.referral, name: labelName },
      }));
    } else if (LookUpType === Lookups.Department) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        department: { ...prevState.department, name: labelName },
      }));
    } else if (LookUpType === Lookups.Role) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        role: { ...prevState.role, name: labelName },
      }));

      if (Number(newAllDropDown?.role?.id) == Number(iseditingLookup?.Id)) {
        setuserToEditt((prevState: any) => ({
          ...prevState,
          clinicianRoleId: iseditingLookup?.Id,
        }));
      }
    }
  };
  async function createNewLabel(labelName: string) {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setIsDisabled(true);
    // console.log(newAllDropDown)
    if (labelName == "") {
      labelName = iseditingLookup.Label;
    }
    let obj1 = validationNamePattern(labelName);
    if (obj1.isSuccess) {
      try {
        let obj;
        if (iseditingLookup.IseditingLookups) {
          obj = getParmeters(
            iseditingLookup.LookUp,
            labelName,
            iseditingLookup.Id
          );
        } else {
          obj = getParmeters(LookUpType, labelName, 0);
        }
        await AddUpdateLookups(obj?.body, obj?.url)
          .then(async function (response) {
            if (response!.data.isResponseSuccessfull) {
              setShowModal2(false);
              if (
                iseditingLookup.IseditingLookups &&
                iseditingLookup.LookUp === LookUpType
              ) {
                updateEditedLookup(labelName);
              }
              if (iseditingLookup.IseditingLookups) {
                setIseditingLookup((prevState) => ({
                  ...prevState,
                  IseditingLookups: true,
                }));
              } else {
                setIseditingLookup((prevState) => ({
                  ...prevState,
                  IseditingLookups: false,
                  Id: 0,
                  Label: "",
                }));
              }
              // console.log("labelName: ", labelName);
              setIsLookupUpdated(labelName);
            } else {
              // console.log(errors);
              setError("name", {
                type: "server",
                message: response!.data.errorMessage.replace(
                  "Data",
                  getHeaderText(LookUpType)
                ),
              });
            }
          })
          .catch((error) => {
            history.push("/confirmation", {
              actionType: ActionType.FailureAPIResponse,
            });
          });
      } catch (error) {
        console.error(error);
      }
    } else {
      setIsDisabled(false);
      if (iseditingLookup.IseditingLookups) {
        setError("name", {
          type: "server",
          message: obj1.error.replace(
            "Data",
            getHeaderText(iseditingLookup.LookUp)!
          ),
        });
      } else {
        setError("name", {
          type: "server",
          message: obj1.error.replace("Data", getHeaderText(LookUpType)!),
        });
      }
    }
  }

  return (
    <div className="bg-custom" id="lookup-modal">
      <div className="create-new-tag-custom">
        {iseditingLookup.IseditingLookups && (
          <h3>Edit {getHeaderText(iseditingLookup.LookUp)}</h3>
        )}
        {!iseditingLookup.IseditingLookups && (
          <h3>Create New {getHeaderText(LookUpType)}</h3>
        )}
        <form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault(); // prevent default Enter submit
            if (!name || name.trim() === "") return; // do nothing if empty
            createNewLabel(name); // call your save function
          }}
        >
          <div className={`field-wrap ${errors.name && "error-wrap"}`}>
            <IonLabel className="label" placeholder={undefined}>
              Name *
            </IonLabel>
            <IonInput
              autofocus={false}
              placeholder="Enter name"
              className="input-field"
              type="text"
              {...register("name", {
                required: true,
              })}
              onIonChange={(e) => {
                handleChange(e);
              }}
            ></IonInput>
            {errors?.name?.type === "required" && (
              <p className="error-msg">This field is required</p>
            )}
            {errors.name &&
              errors.name.type === "server" &&
              errors.name.message && (
                <p className="error-msg">{errors.name.message}</p>
              )}
          </div>
          <div className="btn-wrap-sec two-btns">
            <IonButton
              className="generic-btn generic-btn-outline"
              onClick={() => {
                setShowModal2(false);
                setIseditingLookup((prevState) => ({
                  ...prevState,
                  IseditingLookups: false,
                  Id: 0,
                  Label: "",
                }));
              }}
              placeholder={undefined}
            >
              Cancel
            </IonButton>
            <IonButton
              className="generic-btn"
              disabled={isDisabled}
              type="submit"
              placeholder={undefined}
            >
              Save
            </IonButton>
          </div>
        </form>
      </div>
    </div>
  );
};
export default CreateNewLookup;
